(function () {
  const initCarousel = (section) => {
    const track = section.querySelector("[data-bb-carousel-track]");
    const previous = section.querySelector("[data-bb-carousel-previous]");
    const next = section.querySelector("[data-bb-carousel-next]");
    if (!track || !previous || !next) return;

    const updateControls = () => {
      const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
      previous.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= maximum - 1;
    };

    const scroll = (direction) => {
      const card = track.querySelector(".bb-home-collections__item");
      if (!card) return;
      const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
      track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: "smooth" });
    };

    previous.addEventListener("click", () => scroll(-1));
    next.addEventListener("click", () => scroll(1));
    track.addEventListener("scroll", updateControls, { passive: true });
    new ResizeObserver(updateControls).observe(track);
    updateControls();
  };

  document.querySelectorAll("[data-bb-collection-carousel]").forEach(initCarousel);
})();
